import "./EditLocationWarningModal.scss";
import {Modal} from "antd";
import React from "react";
import {getAccountLocationsPage} from "../../../util/Utils";

export interface EditLocationWarningModalProps {
  visible: boolean;
  onCancel: () => void;
  onContinue: () => void;
}

export default function EditLocationWarningModal({visible, onCancel, onContinue}: EditLocationWarningModalProps) {
  const locationAddonPrice = 10;

  return (
    <Modal className={"edit-location-warning-modal"} visible={visible} onCancel={onCancel} okText={'Continue'} onOk={onContinue} width={'600px'}>
      <section>
        <h3>Edit Location</h3>

        <p>
          Changes to Business Name or Address will reflect on all Link Pages and Mobile Menus for this location.
        </p>
        
        <p className="add-loc-link">
          To add or manage locations, go to <a href={getAccountLocationsPage()} target={'_blank'} rel={'noreferrer'}>Account Settings</a>.
        </p>
      </section>
    </Modal>
  );
}
